import Entity from 'utilities/entity';

class Message extends Entity {
    
}

export default new Message();